// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-text {
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
  color: #FF2459 !important;
}

.login-modal .modal-container {
  display: flex;
  width: 480px !important;
  height: unset !important;
  min-height: 400px !important;
  max-height: 550px !important;
  flex-direction: column;
  align-items: flex-start;
  gap: 0 !important;
}
.login-modal .modal-header {
  width: 100% !important;
}
.login-modal .modal-content {
  padding-top: 0 !important;
  width: 100%;
}
.login-modal .signin-options-button {
  color: #FF2459 !important;
}

.login-modal1 .modal-container {
  display: flex;
  width: 480px !important;
  height: 519px !important;
  flex-direction: column;
  align-items: flex-start;
  gap: 0 !important;
}
.login-modal1 .modal-header {
  width: 100% !important;
}
.login-modal1 .modal-content {
  padding-top: 0 !important;
  width: 100%;
}

.login-error1 .modal-container {
  display: flex;
  width: 480px !important;
  height: 535px !important;
  flex-direction: column;
  align-items: flex-start;
  gap: 0 !important;
}
.login-error1 .modal-header {
  width: 100% !important;
}
.login-error1 .modal-content {
  padding-top: 0 !important;
  width: 100%;
}

.login-modal2 .modal-container {
  display: flex;
  width: 480px !important;
  height: 429px !important;
  flex-direction: column;
  align-items: flex-start;
  gap: 0 !important;
}
.login-modal2 .modal-header {
  width: 100% !important;
}
.login-modal2 .modal-content {
  padding-top: 0 !important;
  width: 100%;
}

.login-error2 .modal-container {
  display: flex;
  width: 480px !important;
  height: 449px !important;
  flex-direction: column;
  align-items: flex-start;
  gap: 0 !important;
}
.login-error2 .modal-header {
  width: 100% !important;
}
.login-error2 .modal-content {
  padding-top: 0 !important;
  width: 100%;
}

@media (min-width: 370px) and (max-width: 635px) {
  .login-modal .modal-container {
    display: flex;
    width: 480px !important;
    height: 100% !important;
    max-height: 100% !important;
    flex-direction: column;
    align-items: flex-start;
    gap: 0 !important;
    border-radius: 0 !important;
  }
  .login-modal .modal-header {
    width: 100% !important;
    border-bottom: 1px solid #F3F3F3;
  }
  .login-modal .modal-content {
    padding-top: 0 !important;
    width: 100%;
    height: 100%;
    display: flex !important;
    flex-direction: column !important;
  }
  .login-modal .icon-wrapper {
    background: none !important;
    padding: 0 !important;
  }
  .login-modal .icon-wrapper > * {
    width: 28px !important;
    height: 28px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/login/style.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;EAAA,gCAAA;EACA,yBAAA;AACF;;AAEI;EACE,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AACN;AAEI;EACE,sBAAA;AAAN;AAGI;EACE,yBAAA;EACA,WAAA;AADN;AAII;EACE,yBAAA;AAFN;;AAOI;EACE,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAJN;AAOI;EACE,sBAAA;AALN;AAQI;EACE,yBAAA;EACA,WAAA;AANN;;AAWI;EACE,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AARN;AAWI;EACE,sBAAA;AATN;AAYI;EACE,yBAAA;EACA,WAAA;AAVN;;AAeI;EACE,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAZN;AAeI;EACE,sBAAA;AAbN;AAgBI;EACE,yBAAA;EACA,WAAA;AAdN;;AAoBI;EACE,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAjBN;AAoBI;EACE,sBAAA;AAlBN;AAqBI;EACE,yBAAA;EACA,WAAA;AAnBN;;AAuBE;EAEE;IACE,aAAA;IACA,uBAAA;IACA,uBAAA;IACA,2BAAA;IACA,sBAAA;IACA,uBAAA;IACA,iBAAA;IACA,2BAAA;EArBJ;EAwBE;IACE,sBAAA;IACA,gCAAA;EAtBJ;EAyBE;IACE,yBAAA;IACA,WAAA;IACA,YAAA;IACA,wBAAA;IACA,iCAAA;EAvBJ;EA0BE;IACE,2BAAA;IACA,qBAAA;EAxBJ;EA2BE;IACE,sBAAA;IACA,uBAAA;EAzBJ;AACF","sourcesContent":[".btn-text {\n  text-decoration: none !important;\n  color: #FF2459 !important;\n}\n.login-modal{\n    .modal-container{\n      display: flex;\n      width: 480px !important;\n      height: unset !important;\n      min-height: 400px !important;\n      max-height: 550px !important;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0 !important;\n    }\n  \n    .modal-header{\n      width: 100% !important;\n    }\n  \n    .modal-content{\n      padding-top: 0 !important;\n      width: 100%;\n    }\n\n    .signin-options-button {\n      color: theme('colors.primary') !important;\n    }\n  }\n\n  .login-modal1{\n    .modal-container{\n      display: flex;\n      width: 480px !important;\n      height: 519px !important;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0 !important;\n    }\n  \n    .modal-header{\n      width: 100% !important;\n    }\n  \n    .modal-content{\n      padding-top: 0 !important;\n      width: 100%;\n    }\n  }\n\n  .login-error1{\n    .modal-container{\n      display: flex;\n      width: 480px !important;\n      height: 535px !important;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0 !important;\n    }\n  \n    .modal-header{\n      width: 100% !important;\n    }\n  \n    .modal-content{\n      padding-top: 0 !important;\n      width: 100%;\n    }\n  }\n\n  .login-modal2{\n    .modal-container{\n      display: flex;\n      width: 480px !important;\n      height: 429px !important;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0 !important;\n    }\n  \n    .modal-header{\n      width: 100% !important;\n    }\n  \n    .modal-content{\n      padding-top: 0 !important;\n      width: 100%;\n    }\n  }\n\n  \n  .login-error2{\n    .modal-container{\n      display: flex;\n      width: 480px !important;\n      height: 449px !important;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0 !important;\n    }\n  \n    .modal-header{\n      width: 100% !important;\n    }\n  \n    .modal-content{\n      padding-top: 0 !important;\n      width: 100%;\n    }\n  }\n\n  @media (min-width: 370px ) and (max-width:635px) {\n  .login-modal {\n    .modal-container {\n      display: flex;\n      width: 480px !important;\n      height: 100% !important;\n      max-height: 100% !important;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0 !important;\n      border-radius: 0 !important;\n    }\n  \n    .modal-header{\n      width: 100% !important;\n      border-bottom: 1px solid #F3F3F3;\n    }\n  \n    .modal-content{\n      padding-top: 0 !important;\n      width: 100%;\n      height: 100%;\n      display: flex !important;\n      flex-direction: column !important;\n    }\n\n    .icon-wrapper{\n      background: none !important;\n      padding: 0 !important;\n    }\n\n    .icon-wrapper>*{\n      width: 28px !important;\n      height: 28px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
